
import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    console.log("Stack trace:", error.stack);
    console.log("Error Info:", errorInfo.componentStack);
    window.history.replaceState({}, "", "/");
    const componentStack = errorInfo.componentStack;
    const match = componentStack.match(/\b(at\s)?(\w+)/);
    if (match) {
      console.log("Component name (approx):", match[2]);
    }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback || (
        <div className="p-4 m-4 border border-red-300 bg-red-50 rounded-md">
          <h2 className="text-red-600 font-bold mb-2">Something went wrong.</h2>
          <p className="text-sm text-red-500">{this.state.error?.message}</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
